{
  "dashboard": {
    "title": "Dashboard"
  },
  "devices": {
    "title": "S4 local station"
  },
  "device": {
    "title": "Device"
  },
  "dtwins": {
    "title": "Devices"
  },
  "dtwin": {
    "title": "Device LPP4"
  },
  "users": {
    "title": "Users"
  },
  "user": {
    "title": "User"
  },
  "profiles": {
    "title": "Profiles"
  },
  "applications": {
    "title": "Applications"
  },
  "campaigns": {
    "title": "Campaigns"
  },
  "logs": {
    "title": "Logs"
  },
  "sectors": {
    "details": {
      "title": "Details of sectors {name}"
    },
    "title": "Sectors"
  },
  "parameters": {
    "title": "Parameters"
  },
  "userGroups": {
    "title": "Groups"
  },
  "pkiConnector": {
    "title": "PKI Connector"
  },
  "truststore": {
    "title": "Truststore"
  },
  "firmware": {
    "title": "Firmware"
  },
  "filters": "Filters",
  "certificateAlertReporting": {
    "title": "Reporting"
  },
  "certificate-management": {
    "title": "Certificates"
  },
  "applicationMgts": {
    "title": "Applications"
  },
  "license": {
    "title": "License"
  },
  "userAccount": {
    "title": "User account"
  },
  "about": {
    "title": "About",
    "downloadTitle": "Download logs"
  },
  "deviceConfiguration": {
    "title": "Device configuration"
  },
  "certificates": {
    "title": "Certificates"
  },
  "fleets": {
    "title": "Fleets"
  },
  "businessUnits": {
    "title": "Modify {name}"
  },
  "organizations": {
    "title": "Modify {name}"
  }
}
